export const CHECKOUTACTION = {
  SINGLE: 'SINGLE',
};
